import { createSlice } from '@reduxjs/toolkit';

const divisionSlice = createSlice({
  name: 'division',
  initialState: {
    divisions: []
  },
  reducers: {
    setDivisions(state, action) {
        if (!action || !action.payload || !action.payload.divisions) {
          state.divisions = [];
        } else {
          state.divisions = action.payload.divisions.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()) );
        }      
    },
  },
});

export const divisionActions = divisionSlice.actions;

export default divisionSlice;